import * as constants from "./constants";

/**
 * オブジェクトのポジショニングを行う関数群 ====================================================================================
 */

/**
 * オブジェクトを中央に配置する関数
 * @param  {} stage
 * @param  {} displayObject
 */
export const setPositionCenter = (stage, displayObject) => {
  setPositionDesignation(displayObject, {
    X: stage.canvas.width / 2,
    Y: stage.canvas.height / 2,
  });
};

/**
 * オブジェクトを初期位置に配置する関数
 * top: 240px - (画像の高さ / 2);
 * @param  {} stage
 * @param  {} displayObject
 */
export const setPositionDefault = (stage, displayObject) => {
  // 画像が見切れることはない位置に配置
  const positionY = Math.max(
    240 - displayObject.getTransformedBounds().height / 2,
    displayObject.getTransformedBounds().height / 2
  );
  setPositionDesignation(displayObject, {
    X: stage.canvas.width / 2,
    Y: positionY,
  });
};

/**
 * @param  {} displayObject
 * @param  {} positionMap
 */
export const setPositionDesignation = (displayObject, positionMap) => {
  displayObject.x = positionMap.X;
  displayObject.y = positionMap.Y;
};

/**
 * オブジェクトのデフォルトサイズを取得する関数
 * @param  {} displayObject
 * @param  {} decoType
 */
export const getDefaultScale = (displayObject, decoType) => {
  // デフォルトサイズが定義されていないものは調整しない
  if (constants.defaultSizeMap[decoType] === undefined) {
    return 1;
  }
  const defaultSize = constants.defaultSizeMap[decoType];
  const scaleWidth = defaultSize / displayObject.getBounds().width;
  const scaleHeight = defaultSize / displayObject.getBounds().height;
  return Math.min(scaleWidth, scaleHeight);
};

/**
 * END==================================================================================================================
 */
